module.exports = __webpack_public_path__ + "img/calculator.7ee7c28c.svg";